import { useEffect, useState } from "react";
import API from "../../services/api";
import "./AdminCouponsPage.css";

function AdminCouponsPage() {
  const [matchesPool, setMatchesPool] = useState([]);
  const [couponType, setCouponType] = useState("");
  const [couponMatches, setCouponMatches] = useState([]);
  const [couponStatus, setCouponStatus] = useState("pending");
  
  // Nouveaux états pour la gestion de l'édition et de la liste
  const [allCoupons, setAllCoupons] = useState([]);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadMatches();
    loadAllCoupons();
  }, []);

  const loadMatches = async () => {
    try {
      const res = await API.get("/matches/coupon-pool");
      setMatchesPool(res.data);
    } catch (error) { console.log(error); }
  };

  const loadAllCoupons = async () => {
    try {
      const res = await API.get("/coupons/admin");
      setAllCoupons(res.data);
    } catch (error) { console.log(error); }
  };

  const addRow = () => {
    setCouponMatches(prev => [...prev, { matchId: "", prediction: "", status: "pending", odd: 1 }]);
  };

  const removeMatchRow = (index) => {
    setCouponMatches(prev => prev.filter((_, i) => i !== index));
  };

  const updateMatch = (index, field, value) => {
    const updated = [...couponMatches];
    updated[index][field] = value;
    setCouponMatches(updated);
  };

  // Soumission (Gère la création ET la modification, selon publié ou brouillon)
  const saveCoupon = async (shouldPublish) => {
    if (!couponType) return alert("Veuillez choisir un type de ticket");
    if (couponMatches.length === 0) return alert("Ajoutez au moins un match");

    try {
      const payload = {
        title: couponType === "secure" ? "Coupon Sécurisé" : couponType === "balanced" ? "Coupon Équilibré" : "Coupon Haut Potentiel",
        type: couponType,
        matches: couponMatches,
        globalStatus: couponStatus,
        published: shouldPublish
      };

      if (editingId) {
        // Mode Modification
        await API.put(`/coupons/${editingId}`, payload);
        alert("Coupon mis à jour avec succès ! ✅");
      } else {
        // Mode Création
        await API.post("/coupons", payload);
        alert(shouldPublish ? "Coupon publié avec succès ! 📢" : "Coupon enregistré dans les brouillons ! 📁");
      }

      // Reset du formulaire
      setCouponMatches([]);
      setCouponType("");
      setCouponStatus("pending");
      setEditingId(null);
      loadAllCoupons();
    } catch (error) { console.log(error); }
  };

  // Charger un coupon dans le formulaire pour modification
  const handleEditInit = (coupon) => {
    setEditingId(coupon._id);
    setCouponType(coupon.type);
    setCouponStatus(coupon.globalStatus);
    const formattedMatches = coupon.matches.map(m => ({
      matchId: m.matchId?._id || m.matchId,
      prediction: m.prediction,
      status: m.status,
      odd: m.odd
    }));
    setCouponMatches(formattedMatches);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Suppression
  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce coupon ? 🗑️")) {
      try {
        await API.delete(`/coupons/${id}`);
        loadAllCoupons();
      } catch (error) { console.log(error); }
    }
  };

  const totalOdds = couponMatches.reduce((acc, match) => acc * Number(match.odd || 1), 1);
  const potentialGain = (totalOdds * 10).toFixed(2);

  return (
    <div style={{ padding: 20 }}>
      <h1>Compositions des matchs (Espace Admin)</h1>
      
      {editingId && <p style={{ color: "orange" }}>⚠️ Modification du coupon {editingId} en cours...</p>}

      <select value={couponType} onChange={(e) => setCouponType(e.target.value)}>
        <option value="">Choisir un type</option>
        <option value="secure">Ticket sécurisé</option>
        <option value="balanced">Ticket équilibré</option>
        <option value="high_potential">Ticket haut potentiel</option>
      </select>

      {couponType && (
        <>
          <h2>{couponType === "secure" ? "Coupon Sécurisé" : couponType === "balanced" ? "Coupon Équilibré" : "Coupon Haut Potentiel"}</h2>
          {couponMatches.map((row, index) => (
            <div key={index} style={{ border: "1px solid var(--border)", padding: 10, marginBottom: 10, borderRadius: 5, background: "var(--card)" }}>
              <select value={row.matchId} onChange={(e) => updateMatch(index, "matchId", e.target.value)}>
                <option value="">Choisir un match</option>
                {matchesPool.map(match => (
                  <option key={match._id} value={match._id}>{match.homeTeam} vs {match.awayTeam}</option>
                ))}
              </select>

              <input placeholder="Pronostic" value={row.prediction} onChange={(e) => updateMatch(index, "prediction", e.target.value)} />
              <input type="number" step="0.01" placeholder="Cote" value={row.odd || ""} onChange={(e) => updateMatch(index, "odd", e.target.value)} />

              <select value={row.status} onChange={(e) => updateMatch(index, "status", e.target.value)}>
                <option value="pending">En cours</option>
                <option value="won">Réussi</option>
                <option value="lost">Échec</option>
              </select>

              <button onClick={() => removeMatchRow(index)} style={{ background: "var(--danger)", color: "#fff", border: "none", padding: "5px 10px", marginLeft: 10, cursor: "pointer" }}>🗑 Supprimer</button>
            </div>
          ))}

          <button onClick={addRow} style={{ background: "var(--orange)", color: "var(--white)", marginRight: 10, border: "none", padding: "5px 10px", marginLeft: 10, cursor: "pointer" }}>➕ Ajouter un match</button>

          <h3>Statut global du coupon</h3>
          <select value={couponStatus} onChange={(e) => setCouponStatus(e.target.value)}>
            <option value="pending">En cours</option>
            <option value="won">Réussi</option>
            <option value="lost">Échec</option>
          </select>

          <div style={{ marginTop: 20 }}>
            <button onClick={() => saveCoupon(true)} style={{ background: "var(--vert)", color: "var(--white)", padding: "10px 20px", marginRight: 10, border: "none", cursor: "pointer" }}>
              📢 {editingId ? "Mettre à jour & Publier" : "Publier directement"}
            </button>
            <button onClick={() => saveCoupon(false)} style={{ background: "gray", color: "white", padding: "10px 20px", border: "none", cursor: "pointer" }}>
              📁 {editingId ? "Mettre à jour comme Brouillon" : "Enregistrer en Brouillon"}
            </button>
            {editingId && <button onClick={() => { setEditingId(null); setCouponMatches([]); setCouponType(""); }} style={{ background: "var(--move)", color: "var(--white)", border: "none",  padding: "10px 20px", marginLeft: 10, cursor: "pointer" }}>Annuler l'édition</button>}
          </div>

          <div style={{ background: "var(--border)", color: "var(--white)", padding: 15, marginTop: 15, borderRadius: 10 }}>
            <p>Nombre de matchs : <strong>{couponMatches.length}</strong></p>
            <p>Cote totale : <strong>{totalOdds.toFixed(2)}</strong></p>
            <p>Gain potentiel : <strong>{potentialGain}$</strong></p>
          </div>
        </>
      )}

      <hr style={{ margin: "40px 0", borderColor: "var(--border)" }} />

      {/* SECTION : LISTE DE TOUS LES COUPONS POUR L'ADMIN */}
      <h2>Historique & Gestion des Coupons ({allCoupons.length})</h2>
      <div style={{ display: "grid", gap: "15px" }}>
        {allCoupons.map(coupon => (
          <div key={coupon._id} style={{ padding: 15, border: "1px solid var(--border)", borderRadius: 8, background: "var(--card)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <strong style={{ fontSize: "1.1rem" }}>{coupon.title}</strong> 
              <span style={{ marginLeft: 10, padding: "2px 8px", borderRadius: 4, fontSize: "0.8rem", background: coupon.published ? "green" : "orange", color: "white" }}>
                {coupon.published ? "En Ligne" : "Brouillon"}
              </span>
              <p style={{ margin: "5px 0 0 0", color: "var(--muted)", fontSize: "0.9rem" }}>
                Cote: {coupon.totalOdds?.toFixed(2)} | Status global : {coupon.globalStatus}
              </p>
            </div>
            <div>
              <button onClick={() => handleEditInit(coupon)} style={{ background: "var(--vert)", color: "white", border: "none", padding: "6px 12px", borderRadius: 4, marginRight: 10, cursor: "pointer" }}>⚙️ Modifier</button>
              <button onClick={() => handleDelete(coupon._id)} style={{ background: "var(--danger)", color: "white", border: "none", padding: "6px 12px", borderRadius: 4, cursor: "pointer" }}>🗑️ Supprimer</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminCouponsPage;